import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './font.css'
import registerServiceWorker from './registerServiceWorker';
const rootElement = document.getElementById('root');

ReactDOM.render(<App />,  rootElement);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js